<template>
  <b-card>
    <bulk-record-import-modal
      ref="bulkRecordImportModal"
      tipo-entidade="EmpresaImportacao"
    />
    <empresa-list
      ref="empresaList"
      :carregar="carregar"
      :novo="novo"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :filtros="filtrosPrincipais"
      :info="info"
      filtrar-por-ativo
      :filtros-adicionais="filtrosAdicionaisBusca"
      :mostrar-remover-lote="false"
      @entidades-vinculadas="getUsuariosInativos"
    >
      <template
        slot="botao-adicional"
        slot-scope="{props}"
      >
        <b-btn
          v-b-tooltip.hover
          title="Histórico de propostas"
          variant="none"
          class="vinculo-proposta btn-none rounded-pill icone-acao"
          style="margin-right:0.3rem"
          @click="abrirConsultaProposta(props.row)"
        >
          <font-awesome-icon :icon="faLink" />
        </b-btn>
      </template>
      <template slot="botao-filtro-certificado">
        <div class="col-3 search-group">
          <label
            name="filtroLabelCertificado"
            for="filterCertificado"
            style="left: 1.5rem !important;top: calc( 50% - 0.8rem ) !important;"
            class="fas fa-filter icon"
          />
          <b-select
            v-model="filtros.tipoFiltroCertificado"
            name="filterCertificado"
            class="search-items"
            :placeholder="'Filtro por certificado'"
            @change="pesquisarFiltroCertificado"
          >
            <option
              v-for="(cert, index) in filtroCertificado"
              :key="index"
              :value="cert.value"
            >
              {{ cert.text }}
            </option>
          </b-select>
        </div>
      </template>
      <template slot="icones-acao">
        <div class="col-1 mt-50">
          <a
            v-b-tooltip.hover
            title="Consulta configurável"
            class="mr-1"
            @click="acessaConsulta()"
          >
            <font-awesome-icon
              :icon="['fas', 'magnifying-glass-chart']"
              size="xl"
              color="var(--primary)"
            />
          </a>
          <a
            v-b-tooltip.hover
            title="Trocar responsável"
            @click="abrirTrocaResponsavel()"
          >
            <font-awesome-icon
              :icon="['fas', 'arrow-right-arrow-left']"
              size="xl"
              color="var(--primary)"
            />
          </a>
        </div>
      </template>
      <template slot="botoes-adicionais">
        <filtro-adicional
          v-if="carregado"
          :value="filtros"
          @mais-filtros="maisFiltros($event)"
        />
        <b-button
          variant="success btn-sm"
          style="margin-right: 5px;"
          @click="abrirModalImportacao"
        >
          Importar
        </b-button>
      </template>

      <template
        slot="etiquetas-personalizadas"
        slot-scope="{props}"
      >
        <span
          v-if="props.row.empresaContrato"
          v-b-tooltip.hover
          title="Aguardando assinar a proposta"
          :class="['badge-dados-empresa', { 'badge badge-parcial': props.row.empresaContrato }]"
        >
          Modo parcial
        </span>

      </template>

      <template
        slot="botao-info"
        slot-scope="{props}"
      >
        <b-btn
          :id="`infoBtn${props.row.id}`"
          v-b-tooltip.hover
          v-b-modal="`modalinfo${props.row.id}`"
          title="Informações"
          variant="none"
          :class="['btn-none rounded-pill icone-acao', { 'btn-info': props.row.hasUsuarioInativoVinculado || props.row.erroIntegracaoOmie || props.row.semEmailNfBoletos, 'btn-outline-info': !props.row.hasUsuarioInativoVinculado && !props.row.erroIntegracaoOmie }]"
          style="margin-right:0.3rem"
          @click="mostrarInfo = true"
        >
          <feather-icon icon="InfoIcon" />
        </b-btn>
      </template>
      <!-- Lista de usuários inativos na empresa -->
      <template
        slot="corpo-info-adicional"
        slot-scope="{props}"
      >
        <div v-if="habilitarAtencao(props.row)">
          <hr style="border-top: 1px solid #a3a4a66b !important; margin: 0.5rem 0">
          <b-row>
            <b-col
              cols="12"
              style="text-align:center;"
            >
              <span><strong style="color:red;font-size:16px;">Atenção:</strong></span>
            </b-col>
          </b-row>
          <div v-if="usuariosExternosInativos.length > 0">
            <b-row class="mb-1">
              <b-col
                cols="12"
                style="text-align:center"
              >
                <span>Usuários externos inativos</span>
              </b-col>
            </b-row>
            <div
              v-for="(usuExterno, i) in usuariosExternosInativos"
              :key="i"
              class="mt-50"
            >
              <b-row>
                <b-col
                  cols="12"
                  style="text-align:center"
                >
                  <span
                    class="link-editar-cadastro"
                    @click="acessaUsuarioExterno(usuExterno.id)"
                  >{{
                    `${usuExterno.nome}` }}</span>
                </b-col>
              </b-row>
            </div>
            <hr style="border-top: 1px solid #a3a4a66b !important; margin: 0.5rem 0">
          </div>

          <div v-if="usuariosInternosInativos.length > 0">
            <b-row class="mb-1">
              <b-col
                cols="12"
                style="text-align:center"
              >
                <span>Responsáveis inativos</span>
              </b-col>
            </b-row>
            <div
              v-for="(usuarioInterno, index) in usuariosInternosInativos"
              :key="index"
              class="mt-50"
            >
              <b-row>
                <b-col
                  cols="12"
                  style="text-align:center"
                >
                  <span
                    class="link-editar-cadastro"
                    @click="acessaUsuarioInterno(usuarioInterno.id)"
                  >{{
                    `${usuarioInterno.nome}` }}</span>
                </b-col>
              </b-row>
            </div>
            <hr style="border-top: 1px solid #a3a4a66b !important; margin: 0.5rem 0">
          </div>

          <div v-if="modelo && !modelo.ativo && modelo.id > 0">
            <b-row class="mb-1">
              <b-col
                cols="12"
                style="text-align:center;"
              >
                <span>Modelo inativo</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                style="text-align:center;"
              >
                <span
                  class="link-editar-cadastro"
                  @click="acessaModelo(modelo.id)"
                >{{ `${modelo.descricao}` }}</span>
              </b-col>
            </b-row>
            <hr style="border-top: 1px solid #a3a4a66b !important; margin: 0.5rem 0">
          </div>
        </div>

        <div v-if="props.row.semEmailNfBoletos">
          <b-row class="mb-1">
            <b-col
              cols="12"
              style="text-align:center;"
            >
              <span>E-mail para Recebimento de Boletos e Notas Fiscais</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              style="text-align:center;"
            >
              <span class="">
                Sem informação, campo obrigatório!
              </span>
            </b-col>
          </b-row>
          <hr style="border-top: 1px solid #a3a4a66b !important; margin: 0.5rem 0">
        </div>
        <div v-if="props.row.erroIntegracaoOmie">
          <b-row class="mb-1">
            <b-col
              cols="12"
              style="text-align:center;"
            >
              <span>Integração Omie</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              style="text-align:center;"
            >
              <span>Empresa com erro ou pendente de integração!</span>
            </b-col>
          </b-row>
        </div>
      </template>
    </empresa-list>

    <!-- Tela de troca de responsável -->
    <troca-responsavel
      ref="trocaResponsavel"
      @enviar-pai="mostrarVisualizacao($event)"
    />

    <!--Lista de troca responsavel-->
    <b-modal
      ref="responsavelTroca"
      title="Empresas com processo realizado"
      title-class="font-weight: bold;"
      hide-footer
    >
      <template #default>
        <div
          v-for="(empresa, index) in empresasTrocadas"
          :key="index"
        >
          <b-row>
            <b-col cols="12">
              <span>{{ empresa.razaoSocial }} - {{ empresa.cadastroFederal }}</span>
            </b-col>
          </b-row>
          <hr style="border-top: 1px solid #a3a4a66b !important; margin: 0.5rem 0">
        </div>
      </template>
    </b-modal>

    <!--Lista de propostas vinculadas-->
    <propostas-vinculadas
      v-if="mostrarPropostasVinculadas"
      :empresa-id="empresaId"
      @hidden="fecharConsultaProposta()"
    />
  </b-card>
</template>

<style lang="scss">
.linha-vertical {
  height: 30px;
  /*Altura da linha*/
  border-right: 1px solid rgb(163 164 166 / 88%);
  /* Adiciona borda direita na div como ser fosse uma linha.*/
}

.badge-dados-empresa {
  height: 1.2rem;
  font-size: 10px;
  font-weight: 600;
  border-radius: 2px;
  margin-left: 0.5rem;
}

.badge-dados-controle {
  height: 1.3rem;
  font-size: 10px;
  font-weight: 750;
  border-radius: 2px;
  margin-left: 0.5rem;
  padding: 4px;
}

.badge-parcial {
  background-color: #ff8d00;
}

.badge-controle {
  border-width: 1px;
  border-style: solid;
}

.vinculo-proposta {
  border: 1px solid #1d9553 !important;
  background-color: transparent;
  color: #1d9553 !important;

  :hover {
    color: #1d9553 !important;
  }
}
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faLink } from '@fortawesome/free-solid-svg-icons'
import { can } from '@core/libs/acl/utils'
import api from '@/app-modulo/comuns/empresa/shared/services/api'

export default {
  name: 'EmpresaVisualizacao',
  components: {
    FontAwesomeIcon,
    EmpresaList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
    FiltroAdicional: () => import('@/app-modulo/comuns/empresa/shared/components/filtro-adicional/FiltroAdicional.vue'),
    TrocaResponsavel: () => import('@/shared/components/troca-responsavel/TrocaResponsavel.vue'),
    PropostasVinculadas: () => import('@/app-modulo/comuns/empresa/shared/components/propostas-vinculadas/PropostasVinculadas.vue'),
    BulkRecordImportModal: () => import('@/app-modulo/comuns/bulk-operations/shared/BulkRecordImportModal.vue'),
  },
  data() {
    return {
      faLink,
      colunasListagem: [
        {
          label: 'Razão Social', field: 'razaoSocial', type: 'personalizada', showActive: true, editable: true,
        },
        { label: 'Inscrição', field: 'cadastroFederal' },
        { label: 'Cidade - UF', field: 'cidadeUF' },
        { label: 'Enquadramento', field: 'enquadramento' },
        { label: 'Equipe', field: 'equipe' },
        { label: 'ID', field: 'codigoIntegracao' }],
      filtrosPrincipais: [{ colunas: ['Nome', 'RegistroFederal', 'Cidade', 'UF', 'Enquadramento', 'Equipe', 'CodigoIntegracao', 'Observacao'], valor: null }],
      filtros: {
        usuarios: null,
        usuariosExternos: null,
        modelo: null,
        grupoEmpresarial: null,
        numeroProposta: null,
        tipoFiltroCertificado: 0,
        equipe: null,
        buscaVinculoOmie: [],
      },
      filtroCertificado: [
        { text: '', value: 0 },
        { text: 'Sem certificado', value: 1 },
        { text: 'Com certificado', value: 2 },
      ],
      info: [
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
      empresasTrocadas: [],
      usuariosExternosInativos: [],
      usuariosInternosInativos: [],
      modelo: {},
      carregado: false,
      filtrosAdicionaisBusca: [{
        label: 'Atenção',
        colunas: ['Atencao'],
        valor: true,
      }, {
        label: 'Modo parcial',
        colunas: ['Parcial'],
        valor: true,
      }],
      empresaId: 0,
      mostrarPropostasVinculadas: false,
    }
  },
  computed: {
    permissaoCreate: {
      get() {
        return can('create', this.$route.meta.resource)
      },
    },
    permissaoUpdate: {
      get() {
        return can('update', this.$route.meta.resource)
      },
    },
  },
  methods: {
    habilitarAtencao(row) {
      return (this.modelo && !this.modelo.ativo && this.modelo.id > 0) || (this.usuariosExternosInativos.length || this.usuariosInternosInativos.length) || (row.erroIntegracaoOmie) || (row.semEmailNfBoletos)
    },
    pesquisarFiltroCertificado() {
      this.$refs.empresaList.montarGrid()
    },
    carregar(page, pageSize, filtro) {
      this.carregado = true
      const filtros = {
        filtroPricipal: filtro,
        filtrosAdicionais: this.filtros,
      }
      return api.getEmpresas(page, pageSize, filtros)
    },
    novo() {
      this.$router.push({ name: 'novo-emp' })
    },
    editar(value) {
      this.$router.push({ name: 'editar-emp', params: { id: value.id } })
    },
    remover(values) {
      if (values && values.length === 1) {
        return new Promise((resolve, reject) => {
          api.delete(values[0].id)
            .then(() => {
              resolve(false)
            })
            .catch(err => {
              reject(err)
            })
        })
      }

      const idList = values.map(map => map.id)
      return new Promise((resolve, reject) => {
        api.deleteAll({ identificadores: idList })
          .then(() => {
            resolve(false)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    abrirTrocaResponsavel() {
      this.$refs.trocaResponsavel.$refs.modalTrocaResponsavel.show()
    },
    mostrarVisualizacao(empresas) {
      this.empresasTrocadas = empresas
      this.$refs.responsavelTroca.show()
    },
    getUsuariosInativos(rowId) {
      api.getUsuariosInativos(rowId)
        .then(payload => {
          this.usuariosExternosInativos = payload.data.usuariosExternos
          this.usuariosInternosInativos = payload.data.usuariosInternos
          this.modelo = payload.data.modelo
        })
    },
    acessaUsuarioExterno(id) {
      this.$router.push(`/usuarios-externos/editar/${id}`)
    },
    acessaUsuarioInterno(id) {
      this.$router.push(`/usuarios-internos/editar/${id}`)
    },
    acessaModelo(id) {
      this.$router.push(`/modelos/editar/${id}`)
    },
    acessaConsulta() {
      this.$router.push({ name: 'consulta-configuravel' })
    },
    maisFiltros(filtros) {
      this.filtros = filtros
      this.$refs.empresaList.montarGrid()
    },
    abrirConsultaProposta(row) {
      this.mostrarPropostasVinculadas = true
      this.empresaId = row.id
    },
    fecharConsultaProposta() {
      this.mostrarPropostasVinculadas = false
      this.empresaId = 0
    },
    abrirModalImportacao() {
      this.$refs.bulkRecordImportModal.showBulkImportModal()
    },
  },
}
</script>
